// extracted by mini-css-extract-plugin
module.exports = {"root":"Stickyfooter_root__1fgKt","button-group":"Stickyfooter_button-group__34oaR"};